import React from "react";
import CarForm from "./carForm.jsx";
const NewCar=()=>{
return <CarForm type={"new"}carId={0}/>
}
export default NewCar;